import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

import { exportRfqTemplate } from '@app/core/_constant/export-template/rfq.constants';
import { AuthService } from '@app/core/auth';
import { PermissionService } from '@app/core/auth/services/permission.service';
import { ClientUsersService } from '@app/core/client/services/client-users.service';
import { CompanyService } from '@app/core/client-user';
import { ExportTemplateRfqService } from '@app/core/quotes/services/export-template-rfq.service';

import { ExportTemplateRfqPopupFormComponent } from '../export-template-rfq-popup-form/export-template-rfq-popup-form.component';

@Component({
  selector: 'export-template-rfq',
  templateUrl: './export-template-rfq.component.html',
  styleUrls: ['./export-template-rfq.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExportTemplateRfqComponent implements OnInit {
  private params :any = {
    per_page: 5,
    page: 1,
  };

  public fields :Array<any> = [
    'Product Name',
    'Product URL',
    'Master SKU #',
    'Variant SKU #',
    'Alternate SKUs',
    'UPC',
    'Location Warehouse',
    'Locations',
    'Unit Cost (FIFO)',
    'Wholesale Cost',
    'Retail Cost',
    'Qty On Hand',
    'Qty Incoming',
    'Qty Available',
    'Qty Pending',
    'Re-Order Level',
    'Low Stock Alert Quantity',
    'Minimum Stock',
    'Last Month Sale Qty',
    'Product Description',
    'Product Category',
    'Product Sub Category',
    'Preferred Vendor',
    'Product Tags',
    'Product Weight',
    'Product Dimensions',
    'Shipping Weight',
    'Shipping Dimensions',
    'Box Weight',
    'Box Dimensions',
    'Carton Weight',
    'Carton Dimensions',
    'Pallet Weight',
    'Pallet Dimensions',
    'Cartons per pallet',
    'Units per pallet',
    'Units per carton',
    'Product Links',
    'Materials',
    'Link to Product Photo',
    'Link to Product Design',
    'Default Receiving Bin',
  ];

  pageSizeOptions :number[] = [5, 10, 25, 100];

  templates :any = { data: [] };

  filter :any = {};

  subscription :Subscription;

  @Output() export :EventEmitter<any> = new EventEmitter();

  constructor(
    public activeModal :NgbActiveModal,
    private modalSvc :NgbModal,
    public exportTemplateRfqService :ExportTemplateRfqService,
    private cd :ChangeDetectorRef,
    private toastr :ToastrService,
    public UserPermission :PermissionService,
  ) {}

  ngOnDestroy() :void {
    this.subscription.unsubscribe();
  }

  ngOnInit() :void {
    this.getRecords(false, 1);

    this.subscription = this.exportTemplateRfqService.templates$.subscribe(
      (records) => {
        this.templates = records;
        this.cd.detectChanges();
      },
    );

    if (!this.UserPermission.can('exportUnitCost')) {
      this.fields.splice(7, 3);
    }
  }

  getRecords(event ?:any, page ?:number) :void {
    if (page) {
      this.params.page = page;
    }

    this.params = Object.assign(this.params, this.filter);
    this.params = Object.entries(this.params).reduce(
      (a, [k, v]) => (v ? ((a[k] = v), a) : a),
      {},
    );

    if (event) {
      this.params.page = event.pageIndex + 1;
      this.params.per_page = event.pageSize;
    }

    this.params.type = exportRfqTemplate.type;

    this.exportTemplateRfqService.setParams(this.params);
    this.exportTemplateRfqService.refreshList();
  }

  addTemplate() :void {
    this.modalSvc.open(ExportTemplateRfqPopupFormComponent, {
      size: 'lg',
    });
  }

  editTemplate(template :any) :void {
    const modalRef = this.modalSvc.open(ExportTemplateRfqPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.exportTemplateRfq = template;
  }

  deleteTemplate(template :any) :void {
    Swal.fire({
      title: 'Confirm delete?',
      text: 'Delete client user?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.exportTemplateRfqService
          .deleteTemplate(template.id)
          .subscribe((resp :any) => {
            this.toastr.success(
              'Successfully deleted product template.',
              'Success',
            );
          });
      }
    });
  }

  exportTemplate(template :any, fileType :string) :void {
    const data = {
      template: template,
      fileType: fileType,
    };
    this.export.emit(data);
  }
}
